import { useEffect, useState } from 'react';
import { useErrorReporter } from '@lib/errorReporter';
const GEOLOCATION_TIMEOUT_MS = 10000;
const useGeolocation = () => {
    const errorReporter = useErrorReporter();
    const [geolocationStatus, setGeoLocationStatus] = useState('getting');
    const [isGettingLocation, setIsGettingLocation] = useState(false);
    const getGeolocationStatus = async () => {
        if (!navigator?.permissions?.query) {
            setGeoLocationStatus('prompt');
            return 'prompt';
        }
        setIsGettingLocation(true);
        let state = 'prompt';
        try {
            const result = await navigator.permissions.query({ name: 'geolocation' });
            state = result.state;
        }
        catch (error) {
            errorReporter.warning(error instanceof Error ? error : new Error(String(error)));
            state = 'prompt';
        }
        if (state === 'prompt')
            setGeoLocationStatus('prompt');
        if (state === 'denied')
            setGeoLocationStatus('denied');
        if (state === 'granted')
            setGeoLocationStatus('granted');
        setIsGettingLocation(false);
        return state;
    };
    const getCurrentPosition = (onPermisonsApproved, onPermisonsRejected) => {
        if (!navigator?.geolocation) {
            onPermisonsRejected('unavailable');
            setGeoLocationStatus('denied');
            setIsGettingLocation(false);
            return;
        }
        setIsGettingLocation(true);
        const timeoutId = setTimeout(() => {
            onPermisonsRejected('timeout');
            setGeoLocationStatus('denied');
            setIsGettingLocation(false);
        }, GEOLOCATION_TIMEOUT_MS);
        navigator.geolocation.getCurrentPosition(async (position) => {
            clearTimeout(timeoutId);
            const approvalResult = await onPermisonsApproved(position.coords);
            if (approvalResult !== false) {
                setGeoLocationStatus('granted');
            }
            setIsGettingLocation(false);
        }, () => {
            clearTimeout(timeoutId);
            onPermisonsRejected('denied');
            setGeoLocationStatus('denied');
            setIsGettingLocation(false);
        }, { timeout: GEOLOCATION_TIMEOUT_MS });
    };
    useEffect(() => {
        getGeolocationStatus();
    }, []);
    return {
        geolocationStatus,
        getCurrentPosition,
        getGeolocationStatus,
        isGettingLocation
    };
};
export default useGeolocation;
